import * as types from '../actiontypes';
import { API_RESOURCES, HTTP_REQUEST_METHODS, createApiReadAction, createApiUpdateAction } from '../../util/api';
import { createApiAction, PatchRiskFactorRelationUrl, PostRiskFactorRelationUrl } from '../apiUrls';

export const RiskFactorsValidExpands = {
	formHeaders: 'formheader'
};

export const getRiskFactors = (engagementId, queryParameters, actionArgs, trackWithArea) => {
	return createApiReadAction(
		types.GET_RISKS_FACTORS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKFACTORS.RISKFACTORS]: undefined
		},
		queryParameters,
		{
			...actionArgs,
			resolve: true
		},
		undefined,
		trackWithArea
	);
};

export const updateRiskFactorRelation = (
	engagementId,
	headerId,
	riskFactorId,
	riskFactorRelationId,
	data,
	trackWithArea
) => {
	return createApiUpdateAction(
		types.UPDATE_RISK_FACTOR_RELATION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKFACTORS.RISKFACTORS]: riskFactorId,
			[API_RESOURCES.RISKFACTORS.RELATIONS]: riskFactorRelationId
		},
		data,
		HTTP_REQUEST_METHODS.PATCH,
		{ headerId, riskFactorId, riskFactorRelationId },
		trackWithArea
	);
};

export const updateRiskFactorRelationDescription = (
	engagementId,
	riskFactorId,
	riskFactorRelationId,
	sectionId,
	bodyId,
	optionId,
	customDescription,
	documentId
) => {
	const url = PatchRiskFactorRelationUrl(engagementId, riskFactorId, riskFactorRelationId);

	const data = [{ op: 'replace', path: '/customDescription', value: customDescription },
	{ op: 'replace', path: '/documentId', value: documentId }];

	return createApiAction(types.UPDATE_RISK_FACTOR_RELATION_DESCRIPTION, url, 'PATCH', data, undefined, {
		sectionId,
		bodyId,
		optionId,
		riskFactorId
	});
};

export const createRiskFactorRelation = (
	engagementId,
	formBodyOptionId,
	formBodyOptionActionId,
	customDescription,
	riskFactorId,
	sectionId,
	bodyId,
	documentId
) => {
	const url = PostRiskFactorRelationUrl(engagementId);

	const data = {
		formBodyOptionId,
		formBodyOptionActionId,
		customDescription,
		documentId
	};

	return createApiAction(types.CREATE_RISK_FACTOR_RELATION, url, 'POST', data, undefined, {
		sectionId,
		bodyId,
		riskFactorId,
		formBodyOptionId
	});
};

export const setMyRiskFactorDescriptions = (
	engagementId,
	riskFactors
) => {
	return {
		type: types.SET_MY_RISK_FACTOR_DESCRIPTIONS,
		engagementId: engagementId,
		riskFactors: riskFactors
	};
};

export const relateRiskFactorToDescription = (
	riskFactorId,
	description,
	oldDescription
) => {
	return {
		type: types.RELATE_RISK_FACTOR_TO_DESCRIPTION,
		riskFactorId: riskFactorId,
		description: description,
		oldDescription: oldDescription
	};
};

export const unRelateRiskFactorFromDescription = (
	riskFactorId,
	description
) => {
	return {
		type: types.UNRELATE_RISK_FACTOR_FROM_DESCRIPTION,
		riskFactorId: riskFactorId,
		description: description
	};
};

export const removeRiskFactorRelation = (
	engagementId,
	formBodyOptionId,
	riskFactorId,
	sectionId,
	bodyId,
	riskFactorRelationId,
	documentId
) => {
	const url = `${PostRiskFactorRelationUrl(engagementId)}/${riskFactorId}/Relation/${riskFactorRelationId}?documentId=${documentId}`;

	return createApiAction(types.REMOVE_RISK_FACTOR_RELATION, url, 'DELETE', undefined, undefined, {
		sectionId,
		bodyId,
		riskFactorId,
		formBodyOptionId,
		engagementId
	});
};

export const editRiskFactorDescription = (
	riskFactorId,
	description,
	oldDescription
) => {
	return {
		type: types.EDIT_RISK_FACTOR_DESCRIPTION,
		riskFactorId: riskFactorId,
		description: description,
		oldDescription: oldDescription
	};
}

export const findRiskFactorDescription = (slice, riskFactorId) => {	
	return slice.riskFactors.byId[riskFactorId]?.customDescription;
}

export const findRiskFactorFromFormData = (state, bodyId, formBodyOptionId, riskFactorId, formSectionId) => {
	let riskFactor;

	let section = formSectionId ? state.find((x) => x.sectionId === formSectionId) : state[0];

	if (section?.bodies?.length > 0) {
		let rf = section.bodies.find((b) => b.id === bodyId);
		if (rf && rf.optionsAndResponses) {
			let rfOptions = rf.optionsAndResponses.find((o) => o.bodyOptionId === formBodyOptionId);
			if (rfOptions && rfOptions.riskFactorList) {
				riskFactor = rfOptions.riskFactorList.find((rf) => rf.id === riskFactorId)
			}
		}
	}

	return riskFactor;
}

export const dropdownActions = {
	add: 'add',
	edit: 'edit',
	remove: 'remove'
};
